var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRamiUsoGeneralPapel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#008918;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.9,18.5c0.8,0.8,1.9,1.1,3.2,1.1s2.4-0.4,3.2-1.1c0.8-0.8,1.2-1.8,1.2-3.1v-10h3.4v10 c0,1.5-0.3,2.7-0.9,3.8c-0.6,1.1-1.5,1.9-2.7,2.5s-2.5,0.9-4.1,0.9s-3-0.3-4.1-0.9c-1.2-0.6-2.1-1.4-2.7-2.5s-0.9-2.4-0.9-3.8v-10 h3.4v10C141.7,16.7,142.1,17.7,142.9,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.2,8.5c-1-0.3-1.8-0.4-2.5-0.4c-0.8,0-1.5,0.1-1.9,0.4c-0.5,0.3-0.7,0.7-0.7,1.2s0.2,0.9,0.5,1.2 c0.3,0.3,0.7,0.6,1.2,0.8s1.2,0.4,2,0.7c1.2,0.3,2.2,0.7,3,1s1.4,0.8,2,1.5c0.5,0.7,0.8,1.5,0.8,2.6c0,1-0.3,1.9-0.9,2.7 c-0.6,0.8-1.4,1.3-2.4,1.8c-1,0.4-2.2,0.6-3.5,0.6c-1.4,0-2.7-0.2-4.1-0.7c-1.3-0.5-2.5-1.1-3.5-2l1.4-2.8c0.9,0.8,1.9,1.4,3,1.9 s2.2,0.7,3.1,0.7c0.9,0,1.7-0.2,2.2-0.5s0.8-0.8,0.8-1.4c0-0.5-0.2-0.9-0.5-1.2s-0.7-0.6-1.3-0.8c-0.5-0.2-1.2-0.4-2.1-0.7 c-1.2-0.3-2.2-0.7-2.9-1c-0.8-0.3-1.4-0.8-2-1.5c-0.5-0.7-0.8-1.5-0.8-2.6c0-1,0.3-1.8,0.8-2.6c0.5-0.7,1.3-1.3,2.3-1.7 c1-0.4,2.2-0.6,3.5-0.6c1.2,0,2.3,0.2,3.4,0.5c1.1,0.3,2.1,0.8,3,1.3l-1.4,2.8C169.1,9.2,168.2,8.8,167.2,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.7,6.3c1.4,0.8,2.6,1.8,3.4,3.1c0.8,1.3,1.2,2.8,1.2,4.4s-0.4,3.1-1.2,4.4c-0.8,1.3-2,2.4-3.4,3.2 s-3,1.2-4.8,1.2s-3.4-0.4-4.8-1.2c-1.4-0.8-2.6-1.8-3.4-3.2c-0.8-1.3-1.2-2.8-1.2-4.4s0.4-3.1,1.2-4.4s2-2.4,3.4-3.1 c1.4-0.8,3-1.1,4.8-1.1C185.6,5.2,187.2,5.5,188.7,6.3z M180.9,8.8c-0.9,0.5-1.7,1.2-2.2,2.1s-0.8,1.8-0.8,2.9s0.3,2,0.8,2.9 s1.3,1.6,2.2,2.1s1.9,0.8,3,0.8s2.1-0.3,3-0.8s1.6-1.2,2.2-2.1c0.5-0.9,0.8-1.9,0.8-2.9c0-1.1-0.3-2-0.8-2.9s-1.3-1.6-2.2-2.1 S185,8,183.9,8C182.8,8.1,181.8,8.3,180.9,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.6,34.9h3v6.4c-0.9,0.7-2,1.2-3.3,1.6c-1.3,0.4-2.5,0.6-3.7,0.6c-1.7,0-3.3-0.4-4.8-1.2 c-1.4-0.8-2.6-1.8-3.4-3.2c-0.8-1.3-1.2-2.8-1.2-4.4s0.4-3.1,1.3-4.4c0.8-1.3,2-2.4,3.5-3.1c1.5-0.8,3.1-1.1,4.9-1.1 c1.3,0,2.5,0.2,3.8,0.7c1.2,0.4,2.3,1,3.2,1.8L153,31c-0.7-0.6-1.5-1.1-2.3-1.4s-1.8-0.5-2.7-0.5c-1.1,0-2.1,0.3-3.1,0.8 c-0.9,0.5-1.7,1.2-2.2,2.1c-0.5,0.9-0.8,1.9-0.8,2.9c0,1.1,0.3,2,0.8,2.9s1.3,1.6,2.2,2.1s2,0.8,3.1,0.8c0.6,0,1.2-0.1,1.9-0.3 s1.3-0.4,1.9-0.8v-4.7H151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.6,26.4h13v2.8H163v4.2h8.6v2.8H163v4.3h9.9v2.8h-13.3L159.6,26.4L159.6,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.7,26.4h3.3v16.9h-3.2l-9.1-11.6v11.6h-3.3V26.4h3.2l9.2,11.7L189.7,26.4L189.7,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.4,26.4h13v2.8h-9.6v4.2h8.6v2.8h-8.6v4.3h9.9v2.8h-13.3V26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.3,43.3l-3.1-5c-0.1,0-0.3,0-0.6,0h-4v5h-3.4V26.4h7.4c2.3,0,4.1,0.5,5.3,1.5s1.9,2.5,1.9,4.3 c0,1.3-0.3,2.5-0.9,3.4s-1.5,1.6-2.6,2.1l3.9,5.6H227.3z M219.6,35.5h4c1.3,0,2.3-0.3,2.9-0.8s1-1.3,1-2.4c0-1-0.3-1.8-1-2.3 s-1.7-0.8-2.9-0.8h-4V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.7,43.3l-1.6-3.6h-8.7l-1.6,3.6h-3.5l7.8-16.9h3.5l7.7,16.9H248.7z M239.7,36.9h6.2l-3.1-7.1L239.7,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.5,26.4h3.4v14h7.7v2.9h-11.1V26.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "33.9,36 39.4,43.1 48.9,30 56.2,30 56.2,5.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.9,
    y: 5.3,
    className: "st1",
    width: 8.8,
    height: 38.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.3,
    y: 5.3,
    className: "st1",
    width: 8.8,
    height: 38.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.9,43.7 72.2,43.7 72.2,11 81,19.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "98.4,43.7 107.2,43.7 107.2,11 98.6,19.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.2,5.3 81.9,5.3 89.5,14.9 97.7,5.2 107.2,5.3 107.2,8.6 89.5,26.4 72.2,8.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.9,14.5L38,43.4H26.8L7.1,18.1V5.2h18.3c0,0,9.9,0.5,10.8,12.4c0,0,0.6,8.8-6.7,12.2l-6.4-8.1 c0,0,3.5,0.6,3.5-3.5c0,0,0-3.5-3.3-3.7L15.9,14.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7,20 15.9,31.5 16,43.4 7.1,43.4  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7,20.3 16,31.8 16,43.8 7.1,43.8  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamiUsoGeneralPapel);
export default __webpack_public_path__ + "static/media/rami-uso-general-papel.ba10439243a79c57a211dc93ca1a8efd.svg";
export { ForwardRef as ReactComponent };